import { ConsumerPortalPaymentPage } from "features/consumerPortalPaymentPage";

function MakePaymentPage() {
  return <ConsumerPortalPaymentPage />;
}

export default MakePaymentPage;
